import { useLocation, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { attendeeTicketsSelector } from 'src/redesign/features/Attendees/store/selectors';
import { useEffect } from 'react';
import { fetchAttendeeTickets } from 'src/redesign/features/Attendees/store/actions';
import { attendeeEventsSidebarActions } from 'src/redesign/features/AttendeeEventsSidebar/store/reducer';

export function useCheckAttendeeEventsSidebarUrl() {
  const location = useLocation();
  const { cartId } = useParams<{ cartId: string }>();
  const attendeeTickets = useAppSelector(attendeeTicketsSelector);
  const dispatch = useAppDispatch();
  const actions = attendeeEventsSidebarActions;

  useEffect(() => {
    if (location.pathname.includes('/ticket/')) {
      if (!attendeeTickets) {
        dispatch(fetchAttendeeTickets());
        return;
      }
      const currentEvent = attendeeTickets.find((ticket) => ticket.cart_id === cartId);
      dispatch(actions.setCurrentEvent(currentEvent));
      dispatch(actions.showAttendeeEventsSidebar());
    }
  }, [location.pathname, cartId, dispatch, attendeeTickets]);
}
